import { set, get } from 'lodash';
import { LOCAL_STORAGE_KEY } from '@/constants';
import { Money } from '@/models/money';
import { ExportToCsv } from 'export-to-csv';
import { formatToShortString } from '@/utils/number';

export const saveToLocalStorage = (path: string, payload: unknown) => {
    const storageObject = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_KEY) || '{}'
    );

    set(storageObject, path, payload);

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storageObject));
};

export const getFromLocalStorage = <T>(path: string, defaultValue?: T): T => {
    const storageObject = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_KEY) || '{}'
    );

    return get(storageObject, path, defaultValue) as T;
};

export const deleteFromLocalStorage = (path: string) => {
    const storageObject = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_KEY) || '{}'
    );

    const deleted = delete storageObject[path];

    if (deleted) {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storageObject));
    }
};

export const getMoneyAsString = (money: Money) => {
    switch (money.currency) {
        case 'EUR':
            return `€${'\u00A0'}${new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(money.amount)}`;
        default:
            return formatToShortString(money.amount);
    }
};

export const numberToPixel = (pixelInNumber: number): string =>
    `${pixelInNumber}px`;

export const convertItemsToCSV = <T extends object>(
    items: T[],
    delimiter: ',' | ';' = ',',
    headers: string[] = []
): string => {
    const csvExporter = new ExportToCsv({
        fieldSeparator: delimiter,
        showLabels: headers.length > 0,
        headers: headers,
    });

    return csvExporter.generateCsv(items, true);
};

// TODO: Should be deprecated
export const downloadContent = (filename: string, content: string) => {
    const element = document.createElement('a');

    element.setAttribute(
        'href',
        'data:text/plain;charset=utf-8,' + encodeURIComponent(content)
    );
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
};

export const downloadContentGeneric = (filename: string, content: string) => {
    const element = document.createElement('a');

    element.setAttribute('href', content);
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
};
